module.exports = __webpack_public_path__ + "static/media/teamsun.85070340.png";